import { eAuthority } from 'ui-toolkit/enums/eAuthority';

const prettyAuthority: Record<eAuthority, string> = {
  [eAuthority.City]: 'City',
  [eAuthority.County]: 'County',
  [eAuthority.State]: 'State',
  [eAuthority.Local]: 'Local',
};

export const authorityOptions: { value: eAuthority; label: string }[] = Object.keys(eAuthority).map((k: string) => ({
  value: eAuthority[k as eAuthority],
  label: prettyAuthority[eAuthority[k as eAuthority]],
}));
